// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"80a4e7ff","795":"cd32c6fb"}[chunkId] + ".chunk.css";
};